import { OptionTemplate, Product } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";

export const BusinessProfielModal = (props: {
  product: Product;
  extra: OptionTemplate[] | null;
}) => {
  const headClass = "gg-px-5 gg-pt-3 gg-text-start";
  const cellClass = "gg-px-5 gg-pb-4 gg-pt-0";

  // Color price
  const doorColorPrice = "€" + (props.product.doorColor.price ?? 0).toFixed(2);

  // Layout price
  const doorLayoutPrice =
    "€" + (props.product.doorLayout.price ?? 0).toFixed(2);

  // Extra options prices
  const doorExtraOptionsPrices = props.product.extraOptionsPrices;

  // Conditions to show extras
  const showDoorExtraOptionsPrices =
    doorExtraOptionsPrices && doorExtraOptionsPrices.length > 0;

  return (
    <div className="gg-h-full gg-bg-gray-100 gg-py-1">
      <table className="gg-w-full">
        <thead>
          <tr>
            <th className={headClass}>
              <Heading headingLevel="h5">Kleur</Heading>
            </th>
            <th className={headClass}>
              <Heading headingLevel="h5">Type</Heading>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cellClass}>
              <p>
                {props.product.doorColor.name}&nbsp;
                <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
                  ({doorColorPrice})
                </span>
              </p>
            </td>
            <td className={cellClass}>
              <p>
                {props.product.doorLayout.name}&nbsp;
                <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
                  ({doorLayoutPrice})
                </span>
              </p>
            </td>
          </tr>
        </tbody>

        <thead>
          <tr>
            <th className={headClass}>
              <Heading headingLevel="h5">Extra opties</Heading>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cellClass}>
              <ul className="">
                {props.extra && props.extra.length > 0 ? (
                  props.extra.map((option: OptionTemplate, index) => (
                    <li
                      className={index === 0 ? "gg-pt-1" : ""}
                      key={option.id}
                    >
                      - {option.name}&nbsp;
                      <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
                        (
                        {showDoorExtraOptionsPrices &&
                          "€" + doorExtraOptionsPrices[index].toFixed(2)}
                        )
                      </span>
                    </li>
                  ))
                ) : (
                  <>-</>
                )}
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
